module.exports = __webpack_public_path__ + "static/media/incog.1727cda1.png";